export const exerciseShortName = (name) => {
  if (!name) return "";
  const words = name.split(" ");
  let shortName = "";
  words.forEach((word) => {
    const limit = word.length > 3 ? 3 : word.length - 1;
    shortName += word.toUpperCase().slice(0, limit) + ". ";
  });
  return shortName;
};

export const signout = () => {
  localStorage.removeItem("jwt");
  // history.push("/")
};

export const getPercentage = (user) => {
  let sum = 0;
  const tot = 9;

  sum += user.cover ? 1 : 0;
  sum += user.firstname.length > 0 ? 1 : 0;
  sum += user.lastname.length > 0 ? 1 : 0;
  sum += user.email.length > 0 ? 1 : 0;
  sum += user.birthdate ? 1 : 0;
  sum += user.sex ? 1 : 0;
  sum += user.height > 0 ? 1 : 0;
  sum += user.weight > 0 ? 1 : 0;
  sum += user.cf ? 1 : 0;

  return Math.round((sum / tot) * 100);
}